import React from "react";
import ReactDOM from "react-dom/client";
import "@/utils/prerenderedHead";
import "@/index.css";
import App from "@/App";
import { installAdminFetchInterceptor } from "@/utils/adminFetch";

// Install the global fetch interceptor BEFORE React mounts so the very
// first admin API call already carries the X-Admin-Password header.
installAdminFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
